import { LitElement, html, TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzChipsItem } from '../types';

export class GzChipsGroupWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  chipsList: GzChipsItem[] = [];

  static get styles() {
    return styles;
  }

  render() {
    return html` <div class="chips-group">${this.chipsList.map(chip => this.renderChipsItem(chip))}</div> `;
  }

  private renderChipsItem(chip: GzChipsItem): TemplateResult {
    const { text, boldSubtext, icon, disabled, removable, notSelectable, color, readonly } = chip;

    return html` <gz-chip
      .text=${text}
      .boldSubtext=${boldSubtext}
      .icon="${icon}"
      .removable="${removable}"
      ?notSelectable="${notSelectable}"
      ?disabled="${disabled}"
      .color=${color}
      ?readonly="${readonly}"
      @removeChip="${this.removeChipHandler}"
    >
    </gz-chip>`;
  }

  private removeChipHandler(event: Event) {
    const targetElement = event.currentTarget as Element;

    if (!targetElement) {
      return;
    }

    targetElement.remove();
  }
}
